export const SOURCE_TRACKING = 'tracking';
export const CODE_TRACKING = 'ETRACKING';



// WEBPACK FOOTER //
// ./Library/1.0/common/tracking/pwa-adapter/pwa-core/constants/ErrorManager.js